import React from 'react'
import './sectionSplit.scss'

const SectionSplit = ({ size, children, className }) => {
	return (
		<div
			className={`section_split${
				size !== undefined ? ` section_split-size${size}` : ''
			} ${className !== undefined ? className : ''}`}
		>
			{children}
		</div>
	)
}

export default SectionSplit
